import TableView from './TableView'

export default TableView
